module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/error-page/error-page.component.css
// module id = ./src/app/components/error-page/error-page.component.css
// module chunks = main